/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'team-central.give-jira-kudos.created.description.flag': '⁣⁢Our Workplace Experience team will now work their magic for the gift request. ✨⁯⁬⁮‍⁬‍⁯‌⁬⁮⁮‌‍⁫⁪⁬⁮⁫⁡⁠⁬⁪⁣⁤',
  'team-central.give-jira-kudos.created.title.flag': '⁣⁢Kudos created⁮⁪‌؜⁮⁪⁠‍⁠⁫⁭⁪⁭‌⁮⁡⁡⁬⁡⁣⁤',
  'team-central.give-jira-kudos.creation.failed.description.flag': "⁣⁢We couldn't create your kudos or send the gift. Try raising a separate ticket at <a>go/kudos</a>..⁠⁡‌‍⁠⁪⁠⁡⁯⁫⁭⁡⁠⁮⁮⁬؜‌⁯⁭؜؜‍⁣⁤",
  'team-central.give-jira-kudos.creation.failed.title.flag': '⁣⁢Something went wrong⁪⁭⁬⁯⁡؜⁬⁯‌⁬⁬⁯⁮⁭‍‌⁯⁬‌⁯⁪⁯‍⁣⁤',
  'team-central.give-kudos.button': '⁣⁢Give kudos‍⁯‌⁠؜⁫⁯‍⁫⁬‍⁬⁡؜‍‌؜⁠⁡⁮⁠⁫‍⁣⁤',
  'team-central.give-kudos.close-button.label': '⁣⁢Close drawer⁭⁭⁯⁮⁫⁮‌⁠⁭⁫⁡‍⁭⁬؜‍⁮⁬⁡⁮⁭⁪⁣⁤',
  'team-central.give-kudos.confirm-close.title': '⁣⁢Confirm Close⁭⁭‍⁠⁮⁫⁯⁯⁭⁭؜⁪⁠⁪‌⁪‌؜‌⁮⁯⁮⁫‍⁣⁤',
  'team-central.give-kudos.created.description.flag': '⁣⁢Your kudos has been sent. <a>View kudos</a>⁪‌؜⁡⁭‌⁯‌⁯⁭⁬⁠⁯؜⁫‌‍⁬⁭⁯⁣⁤',
  'team-central.give-kudos.created.title.flag': '⁣⁢Kudos created⁠⁠⁯⁡⁬⁠⁪⁠‍⁡⁠⁡⁡⁬⁠⁯⁡؜⁫⁮⁡⁣⁤',
  'team-central.give-kudos.creation.failed.description.flag': "⁣⁢We couldn't create your kudos.⁫⁬‌‍⁮‍⁪⁮⁫⁯⁪⁬⁭⁮⁮‌‌⁭⁣⁤",
  'team-central.give-kudos.creation.failed.title.flag': '⁣⁢Something went wrong؜‌⁭⁭؜؜⁯⁭‍⁯⁭⁡⁫⁫⁯؜⁬⁭‍⁫⁫⁬‌؜⁬⁣⁤',
  'team-central.give-kudos.error-icon.label': '⁣⁢Error⁪‌‌⁪‌⁠⁪⁠⁫⁫⁯⁭⁬؜⁪⁮⁫⁭⁫⁠⁮‍⁠⁣⁤',
  'team-central.give-kudos.success-icon.label': '⁣⁢Success⁮⁮‌⁪؜⁯⁠‌⁫⁪⁮‍⁡⁡⁫⁡⁡‍‍⁡؜⁫⁭⁣⁤',
  'team-central.give-kudos.unsaved.warning': '⁣⁢Changes that you made will not be saved.‍⁠⁪⁫؜⁡⁮⁬⁪‍؜⁬⁪؜⁪‌⁪⁭⁬⁫⁯⁯⁡⁡⁣⁤',
  'team-central.give-kudos.unsaved.warning.cancel': '⁣⁢Cancel‌⁬⁯⁠؜‍⁭‌‍⁠⁫⁫⁫؜‌⁠؜‌⁬‍‌؜⁠⁡‍⁠⁫⁣⁤',
  'team-central.give-kudos.unsaved.warning.close': '⁣⁢Close⁠⁭؜⁠⁠⁡⁪⁬⁯⁭⁡⁡‌⁭⁭⁭⁡⁠⁯⁭⁭⁠‍⁭⁣⁤'
};